<template>
    <div>
        <!--新增-->
        <div >
          <el-button type="success" icon="el-icon-circle-plus-outline" @click="add=true" round>添加</el-button>
<!--          <el-button type="danger" icon="el-icon-close" @click="deactivate" round>停用</el-button>-->
        </div>
        <DxDataGrid class="dx-card wide-card" :focused-row-index="0" :show-borders="true" :focused-row-enabled="true" height="600"
                :column-auto-width="true" :column-hiding-enabled="true"
                    :data-source="dataSource"
                :ref="dataGridRefKey"
                :selection="{ mode: 'single' }"
                @selection-changed="selectionChanged"
                @row-updated="logEvent('RowUpdated')"
                key-expr="marketingId">
            <!--加载框-->
            <DxLoadPanel :enabled="true" />
            <dx-paging :page-size="10" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <dx-filter-row :visible="true" /><!--列过滤-->
            <DxColumn data-field="appName" caption="公众号" data-type="string" :hiding-priority="8"/>
            <DxColumn data-field="marketingName" caption="营销名称" data-type="string" :hiding-priority="3"/>
            <DxColumn data-field="sendCount" caption="推送次数" data-type="string" :hiding-priority="3"/>
            <DxColumn data-field="modeId" caption="模板id" data-type="string" :hiding-priority="3"/>
            <DxColumn data-field="createTime" caption="创建时间" data-type="date" :hiding-priority="3"/>

            <DxColumn  type="buttons" :width="125" >
                <DxTextBoxButton hint="列表" icon="menu" :visible="true" :disabled="false" :on-click="redirectInfo" :width="125"/>
                <DxTextBoxButton hint="修改" icon="edit" :visible="true" :disabled="false" :on-click="modifyInfo" :width="125"/>
            </DxColumn>

        </DxDataGrid>


        <DxPopup :width="1000" :height="800" :show-title="true"  :drag-enabled="false" :visible="add" title="添加">
            <DxScrollView width="100%" height="100%" direction="both">
              <marketingAdd @close="add=false" @refresh="getData"></marketingAdd>
            </DxScrollView>
        </DxPopup>

        <!--新增营销信息-->
        <DxPopup target="addMarketing" :maxWidth="660" :minHeight="600" :visible="popupVisibleModify" show-event="dxhoverstart" hide-event="dxhoverend" :resize-enabled="true">
            <template #content="{  }">
                <div class="popup-property-details">
                    <DxScrollView :height="500" :width="600" direction="both">
                        <!--发送消息-->
                        <modifyMessage  @closeProp="closeProp" :activity="activity"></modifyMessage>
                    </DxScrollView>
                </div>
            </template>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"  :options="closeButtonOptions"></DxToolbarItem>
        </DxPopup>

    </div>
</template>
<script>
    import modifyMessage from "@/components/message_modify";
    import marketingAdd from "@/views/wechatPush/marketing/marketingAdd";
    import {getUserDetails} from "@/request/http";
    const dataGridRefKey = 'myDataGrid';

    export default {
        /*营销列表*/
        name: "marketingList",
        components: {
            modifyMessage,marketingAdd
        },
        data(){
            return{

                add:false,
                type:"list",
                dataGridRefKey,
                dataSource:[],
                selectedItemKeys: '',
                selectionChanged: (data) => {
                  this.selectedItemKeys = data.selectedRowKeys[0];
                },
                events: [],
                popupVisible : false,
                popupVisibleModify:false,
                closeButtonOptions: {
                    text: 'Close',
                    onClick: () => {
                        this.popupVisible = false;
                        this.popupVisibleModify = false;
                    },
                },
                formData:{},
                wechatSelect:[
                        { id: 1, country: "产品" },
                        { id: 2, country: "活动" }
                    ],
                wechatNameSelect:[],
                modeSelect:[],
                files: [],
                marketingType:new Object(),
                wxId:new Object(),
                activity:{}
            }
        },
        created() {
            this.getData()
        },

        computed: {
            dataGrid: function() {
                return this.$refs[dataGridRefKey].instance;
            }
        },
        methods:{
            redirectInfo(e){
              this.$router.push({
                  path:'/marketingInfo',
                  query:{
                      "marketingId":e.row.data.marketingId
                  }
              })
            },
            modifyInfo(e){
                this.activity = e.row.data
                this.popupVisibleModify = true;
            },
            fileUploader_abortUpload(file,uploadInfo){
                //console.log(file)
                //console.log(uploadInfo)
            },
            getData(){
                this.$http.get_marketing_list({"type" : 0}).then(res => {
                    if(res.status == "success"){
                        this.dataSource=res.data
                    }

                })
            },
            logEvent(eventName) {
                //console.log(eventName)
                switch (eventName) {
                    case "RowUpdated":
                        //console.log("进行更新操作")
                        break;
                }
            },
            addClick(){
                this.popupVisible = true;
                /*获取微信公众号信息*/
                this.$http.get_wxconfig(null).then(res=>{
                    this.wechatNameSelect = res.data
                })

            },
            submitFrom(){
                // //console.log(this.formData)
                // this.$http.upload_img(this.files[0]).then(res =>{
                //     //console.log(res)
                // })
                //
                // return ;
                const param =this.formData
                param.wxId = this.wxId
                param.marketingType = this.marketingType
                // param.marketingBk = this.files[0]


                //console.log(param)

                this.$http.add_marketing_model(param).then(res=>{
                    //console.log(res)
                    if(res.status == "success"){
                        this.getData()
                        this.popupVisible = false;
                    }
                })

            },
            changeWechatBox(e){
                this.wxId = e.value
                //查找模板
                //根据微信公众号获取所有的模板
                this.$http.get_template_all({"appId":e.value}).then(res =>{
                    this.modeSelect =res.data
                })
            },
            changeTypeBox(e){
                this.marketingType = e.value
            },
            changeModeltBox(e){
                //console.log(e)
            },
            closeProp(){
                this.popupVisible = false
                this.popupVisibleModify = false;
                this.getData()
            },
            deactivate(){

            }
        }
    }
</script>

<style scoped>
.my_submit{
  padding: 10px;
  background-color: #2d6da3;
  color: #ffffff;
  text-align: center;
}
.my_from{
  margin: 40px 0 0 300px;
  text-align: center;
  width: 50%;
  /*display: flex;*/
  /*flex-direction: row;*/
}
.tool_head{
  min-height: 45px;
  margin: 10px;
}
</style>